// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.az-content-left-chat {
  width: 100% !important;
  position: relative;
  display: flex;
  flex-direction: column;
}

.w-100 {
  width: 100% !important;
  height: 100% !important;
}

.az-img {
  max-height: 100px;
  max-width: 400px;
}

.image-cursor {
  cursor: pointer;
}

.img-container {
  width: 100%; /* or any custom size */
  height: 100px !important;
  object-fit: contain;
  padding: 10px !important;
}

.fixed-card {
  height: 170px;
  max-height: 170px;
  margin: auto;
  border: 3px solid rgb(98, 196, 221);
}

.myAppCheckbox {
  width: 20px;
  height: 20px;
  border: 20px solid rgb(98, 196, 221);
  float: left;
  margin: 2px;
  position: absolute;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/mypplications/mypplications.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAGE;EACE,sBAAA;EACA,uBAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,eAAA;AAAJ;;AAGE;EACE,WAAA,EAAA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;;AAGE;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mCAAA;AAAJ;;AAGE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAAJ","sourcesContent":[".az-content-left-chat {\n    width: 100% !important;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n\n  }\n\n  .w-100{\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  .az-img {\n    max-height: 100px;\n    max-width: 400px;\n  }\n\n  .image-cursor {\n    cursor: pointer;\n  }\n  \n  .img-container {\n    width: 100%; /* or any custom size */\n    height: 100px !important; \n    object-fit: contain;\n    padding: 10px !important;\n  }\n\n  .fixed-card {\n    height: 170px;\n    max-height: 170px;\n    margin: auto;\n    border: 3px solid rgb(98, 196, 221);\n  }\n\n  .myAppCheckbox{\n    width: 20px;\n    height: 20px;\n    border: 20px solid rgb(98, 196, 221);\n    float: left;\n    margin: 2px;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
